<template>
  <section class="new-parking-lots">
    <h2 class="section-title">新增停車場</h2>
    <!-- <div class="parking-lots-grid">
      <div v-for="lot in parkingLots" :key="lot.name" class="parking-lot">
        <img :src="lot.image" :alt="lot.name" class="lot-image">
        <h3>{{ lot.name }}</h3>
        <p class="lot-loc">{{ lot.location }}</p>
      </div>
    </div> -->
    <div class="oparking-grid">
      <div class="parking-lots-grid">
        <div v-for="lot in parkingList" :key="lot.name" class="parking-lot">
          <img :src="getFullImageURL(lot.photo_url)" :alt="lot.title" class="lot-image"
            @error="onImageError($event)" />
          <h3 class="item-text-bold">{{ lot.title }}</h3>
          <p class="item-text-small-regular">{{ lot.county }}</p>
        </div>
      </div>
    </div>
    <button class="more-btn" @click="naviageToParkingList()">查看所有停車場</button>
  </section>
</template>

<script>
import { onImageError, getFullImageURL } from '@/util/util';
import PullDAO from '@/services/PullDAO';

export default {
  name: 'NewParkingLots',
  data() {
    return {

      parkingList: [],
      isLoading: false,
      error: null,
      row: 10, // Number of items per page
      page: 1, // Current page for pagination      
    }
  },
  computed: {
  },
  watch: {

  },
  methods: {
    getFullImageURL,
    onImageError,
    attemptGetParkings() {
      console.log('city:', this.city);
      console.log('district:', this.district);
      console.log('parkingType:', this.parkingType);
      this.getParkingList({ row: 10, page: 1 });
    },
    naviageToParkingList() {
      this.$router.push('/parking-lots');
    },

    async fetchParkings() {
      this.isLoading = true;
      this.error = null;

      const pullDAO = new PullDAO();

      console.log(this.newsItems);


      try {
        const newData = await pullDAO.listParkings(this.row, this.page);
        console.log(newData);
        // Append the newly fetched news to the existing array
        this.parkingList = [...this.parkingList, ...newData.parkings];
      } catch (error) {
        this.error = error.message || '無法載入最新停車場。';
      } finally {
        this.isLoading = false;
      }
    },


  },
  mounted() {

    // this.page += 1;
    this.fetchParkings();


  }
}
</script>

<style scoped>
.new-parking-lots {
  /* position: relative; */
  /* padding: 40px 20px; */
  /* margin-top: 100px; */
  /* background-color: #f5f5f5; */

  width: var(--home-component-width);
  /* height: 600px; */
  margin: 0 auto;

}



.oparking-grid {

  display: flex;

  width: 100%;



  max-height: 260px;

  overflow: hidden;
  justify-content: center;
}

.parking-lots-grid {
  display: flex;

  width: 100%;

  /* flex-direction: row; */
  /* grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); */
  grid-template-columns: repeat(6, 1fr);

  gap: 20px;
  margin-bottom: 30px;
  margin: 0 auto;

  /* overflow: hidden; */
  flex-wrap: wrap;
  justify-content: center;

}

.parking-lot {
  flex: 0 0 auto;
  /* Ensure items don't shrink or grow */
  /* width: 150px; /* Set a fixed width for each item */
  /* height: 150px; Set a fixed height for each item   */
  text-align: center;
  max-width: 184px;
  overflow: hidden;
}

.lot-image {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  object-fit: cover;
}

.item-text-bold {
  /* font-weight: bold; */
  color: var(--gray15);
  /* margin: 25px 0 5px; */
  margin-top: 24px;
  margin-bottom: 0px;

  text-wrap: nowrap;

}





@media (max-width: 800px) {}

@media (max-width: 560px) {


  .new-parking-lots {
    /* position: relative; */
    /* padding: 40px 20px; */
    /* margin-top: 60px; */
    /* background-color: #f5f5f5; */

    width:343px;
    /* width: 100%; */
    /* height:440px; */
    /* height: 415px; */
  }



  .parking-lots-grid {
    display: flex;

    width: 1416px;

    height: 200px;

    /* grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); */
    flex-direction: row;
    gap: 20px;
    margin-bottom: 30px;
    margin: 0 auto;

  }

  .parking-lots-grid {
    display: flex;
    flex-direction: row;
    gap: 20px;
    width: 100%;
    /* Full container width */
    max-width: 1416px;
    /* Optional: Limit the width */
    overflow: hidden;
    /* Hide any overflow */
    margin: 0 auto;
    cursor: grab;
    /* Indicate draggable area */
  }

  .parking-lot {
    text-align: center;
    height: 200px;
  }

  .lot-image {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
  }

  .item-text-bold {
    /* margin: 25px 0 5px; */
    margin-top: 16px;
    margin-bottom: 0px;

  }




}

@media (max-width: 360px) {}
</style>
